export const addTeam = async ({ data }) => {
  let newEntry = await fetch(`${process.env.API_URL}/teams/add`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then((r) => r.json());
  // console.log(newEntry);
  return newEntry;
};

export const getTeams = async ({ queryKey }) => {
  const [_key, { limit = 10, page = 1, type = 'all' }] = queryKey;

  let data = await fetch(`${process.env.API_URL}/teams`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      // Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify({ limit, page, type }),
  }).then((r) => r.json());
  return data.data;
};

export const searchTeams = async ({ queryKey, meta }) => {
  const [_key, { limit = 10, page = 1, status = 'all', searchTerm, stage = '', leaderEmail }] = queryKey;

  let data = await fetch(`${process.env.API_URL}/teams/search`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: meta?.token ? `Bearer ${meta.token}` : null,
    },
    body: JSON.stringify({ limit, page, status, stage, searchTerm, leaderEmail }),
  }).then((r) => r.json());
  return data.data;
};

export const activateTeam = async ({ queryKey }) => {
  const [_key, { id }] = queryKey;
  let data = await fetch(`${process.env.API_URL}/teams/${id}/activate`).then((r) => r.json());
  return data.data;
};

export const eliminateTeam = async ({ data, token }) => {
  let updatedEntry = await fetch(`${process.env.API_URL}/teams/${data.team._id}/eliminate`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  }).then((r) => r.json());
  return updatedEntry.data;
};

export const getTeam = async ({ queryKey }) => {
  const [_key, { id }] = queryKey;
  let data = await fetch(`${process.env.API_URL}/teams/${id}`).then((r) => r.json());
  return data.data;
};

export const updateTeam = async ({ data, token, team }) => {
  let newEntry = await fetch(`${process.env.API_URL}/teams/${team}`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  }).then((r) => r.json());
  return newEntry.data;
};

export const updateTeamMembers = async ({ data }) => {
  let newEntry = await fetch(`${process.env.API_URL}/teams/${data.team}/students`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then((r) => r.json());
  return newEntry.data;
};

export const updateTeamMentor = async ({ data }) => {
  let newEntry = await fetch(`${process.env.API_URL}/teams/${data.team}/mentors`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then((r) => r.json());
  return newEntry.data;
};

export const inviteIntoTeam = async ({ data }) => {
  let updatedEntry = await fetch(`${process.env.API_URL}/teams/${data.team._id}/invite`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then((r) => r.json());
  return updatedEntry.data;
};

export const getTeamPresentations = async ({ queryKey }) => {
  const [_key, { id }] = queryKey;
  let data = await fetch(`${process.env.API_URL}/teams/${id}/presentations`).then((r) => r.json());
  return data.data;
};

export const getTeamMessages = async ({ queryKey }) => {
  const [_key, { id, token }] = queryKey;
  let data = await fetch(`${process.env.API_URL}/teams/${id}/messages`, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  }).then((r) => r.json());
  return data.data;
};

export const updateTeamPresentations = async ({ data }) => {
  let newEntry = await fetch(`${process.env.API_URL}/teams/${data.team}/presentations`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then((r) => r.json());
  return newEntry.data;
};
